module.exports = __webpack_public_path__ + "static/RNZ-89d70c4194d19a6f3675ff79b002b4b6.jpg";